/**
 * @fileOverView
 * @description Developer Full View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var DeveloperTemplate = require('../../templates/widgets/developerfulltemplate.html');
var Params = require("../../collections/params");
var ParamView = require("./param");
var oauthClientIdCopyButton = require('../../templates/components/oauthClientIdCopyButton.html');
var oauthClientSecretButtons = require('../../templates/components/oauthClientSecretButtons.html');
var apiKeyCopyButton = require('../../templates/components/apiKeyCopyButton.html');
var apiKeyButtons = require('../../templates/components/apiKeyButtons.html');
var webhooksSecretButtons = require('../../templates/components/webhooksSecretButtons.html');
var webhookReenableButton = require('../../templates/components/webhookReenableButton.html');
var app = require("ampersand-app");
var dialog = require("../../lib/dialog");

var DeveloperFullView = AmpersandView.extend({

    template: DeveloperTemplate,

    initialize: function(options) {
        var entity = 'developer';
        
        this.testAccessToken = null;
        this.testVybits = null;

        this.oauthSettings = new Params([
            {
                "entity": entity,
                "name": "oauth_service_name",
                "label": "SERVICE NAME",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "give your oauth integration a descriptive name",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "oauth_redirect_uri_1",
                "label": "REDIRECT URI 1",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "where users return after oauth authorization",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "oauth_redirect_uri_2",
                "label": "REDIRECT URI 2",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "optional: a staging or http://localhost callback",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "oauth_redirect_uri_3",
                "label": "REDIRECT URI 3",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "optional",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "oauth_client_id",
                "label": "CLIENT ID",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "rightColContent": oauthClientIdCopyButton(),
                "labelNoWrap": true
            },
            {
                "entity": entity,
                "name": "maskedClientSecret",
                "label": "CLIENT SECRET",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "rightColContent": oauthClientSecretButtons(),
                "labelNoWrap": true
            },
            {
                "entity": entity,
                "name": "oauthInstructions",
                "label": "INSTRUCTIONS",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "labelNoWrap": false,
                "labelTopAlign": true
            }
        ]);

        this.apiSettings = new Params([
            {
                "entity": entity,
                "name": "maskedApiKey",
                "label": "API KEY",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "rightColContent": apiKeyButtons(),
                "labelNoWrap": true
            },
            {
                "entity": entity,
                "name": "apiInstructions",
                "label": "INSTRUCTIONS",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "labelNoWrap": false,
                "labelTopAlign": true
            }
        ]);

        this.mcpSettings = new Params([
            {
                "entity": entity,
                "name": "mcpInstructions",
                "label": "INSTRUCTIONS",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "labelNoWrap": false,
                "labelTopAlign": true
            }
        ]);

        this.cliSettings = new Params([
            {
                "entity": entity,
                "name": "cliInstructions",
                "label": "INSTRUCTIONS",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "labelNoWrap": false,
                "labelTopAlign": true
            }
        ]);

        this.webhooksSettings = new Params([
            {
                "entity": entity,
                "name": "webhook_url_1",
                "label": "URL 1",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "https://your-server.com/webhook",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "webhook_url_2",
                "label": "URL 2",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "https://your-server.com/webhook",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "webhook_url_3",
                "label": "URL 3",
                "inputType": "text",
                "template": "TextTemplate",
                "placeholder": "https://your-server.com/webhook",
                "cursor": true
            },
            {
                "entity": entity,
                "name": "maskedWebhooksSecret",
                "label": "SECRET",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "rightColContent": webhooksSecretButtons(),
                "labelNoWrap": true
            },
            {
                "entity": entity,
                "name": "webhooksInstructions",
                "label": "INSTRUCTIONS",
                "inputType": "none",
                "template": "DisplayTemplate",
                "cursor": false,
                "bypassSave": true,
                "labelNoWrap": false,
                "labelTopAlign": true
            }
        ]);

        this.parent = options.parent;
        this.loadOrCreateDeveloperConfig();

        const self = this;
        ['oauthInstructions', 'apiInstructions', 'mcpInstructions', 'cliInstructions', 'webhooksInstructions'].forEach(function(field) {
            self.listenToAndRun(self.model, 'change:' + field, function() { self.render(); });
        });
    },

    render: function() {
        // Save accordion state before rendering
        var accordionState = this.saveAccordionState();

        this.renderWithTemplate();
        this.renderCollection(this.oauthSettings, ParamView, '.vset-oauth');
        this.renderCollection(this.apiSettings, ParamView, '.vset-api');
        this.renderCollection(this.mcpSettings, ParamView, '.vset-mcp');
        this.renderCollection(this.cliSettings, ParamView, '.vset-cli');
        this.renderCollection(this.webhooksSettings, ParamView, '.vset-webhooks');
        this.updateWebhookDisabledLabels();

        // Restore accordion state after rendering
        this.restoreAccordionState(accordionState);

        this.updateClipboardButtons();
        app.utils.clipboard();

        return this;
    },

    saveAccordionState: function() {
        var state = {};
        var accordionSections = this.queryAll('.accordion-collapse');
        if (accordionSections) {
            accordionSections.forEach(function(section) {
                if (section.id) {
                    state[section.id] = section.classList.contains('show');
                }
            });
        }
        return state;
    },

    restoreAccordionState: function(state) {
        if (!state) return;

        var self = this;
        Object.keys(state).forEach(function(sectionId) {
            var section = self.query('#' + sectionId);
            if (section) {
                if (state[sectionId]) {
                    section.classList.add('show');
                } else {
                    section.classList.remove('show');
                }
            }
        });
    },

    events: {
        'click .developer-rotate-secret': 'rotateSecret',
        'click .developer-rotate-api-key': 'rotateApiKey',
        'click .developer-rotate-webhooks-secret': 'rotateWebhooksSecret',
        'click .developer-reenable-webhook': 'reEnableWebhook',
        'click .test-auth-button': 'testAuthorization',
        'click .test-token-button': 'testTokenRequest',
        'click .test-verify-button': 'testVerifyAuthorization',
        'click .test-vybit-list-button': 'testVybitList',
        'click .test-trigger-button': 'testTriggerVybit',
        'change #vybit-select': 'onVybitSelectionChange',
        'input #trigger-message': 'onTriggerParameterChange',
        'input #trigger-image': 'onTriggerParameterChange',
        'input #trigger-link': 'onTriggerParameterChange',
        'input #trigger-log': 'onTriggerParameterChange'
    },

    setButtonState: function(selector, disabled, text) {
        const button = this.query(selector);
        if (button) {
            button.disabled = disabled;
            if (text) button.textContent = text;
        }
        return button;
    },

    loadOrCreateDeveloperConfig: function() {
        var self = this;
        
        this.model.fetch({
            success: function(model, response) {
                console.log('Developer config loaded:', response);
                self.model = model;
                app.developer = model;
                self.render();
            },
            error: function(model, response) {
                if (response.statusCode === 404) {
                    console.log('No developer config found, creating new one...');
                    self.createDeveloperConfig();
                } else {
                    console.error('Error loading developer config:', response);
                }
            }
        });
    },

    createDeveloperConfig: function() {
        var self = this;
        
        var newConfig = new app.Developer({
            oauth_service_name: '',
            oauth_redirect_uris: []
        });
        
        newConfig.save({}, {
            success: function(model, response) {
                console.log('Developer config created:', response);
                
                model.set(response);
                self.model = model;
                app.developer = model;
                self.render();
            },
            error: function(model, response) {
                console.error('Error creating developer config:', response);
            }
        });
    },

    updateClipboardButton: function(buttonClass, value) {
        var button = this.query('button.' + buttonClass);
        if (button && value) {
            button.setAttribute('data-clipboard-text', value);
        }
    },

    updateClipboardButtons: function() {
        if (!app.developer) return;
        this.updateClipboardButton('vcopy-client-id', app.developer.oauth_client_id);
        this.updateClipboardButton('vcopy-client-secret', app.developer.oauth_client_secret);
        this.updateClipboardButton('vcopy-api-key', app.developer.api_key);
        this.updateClipboardButton('vcopy-webhooks-secret', app.developer.webhooks_secret);
    },

    confirmRotate: async function(message, rotateFn, label) {
        if (!await dialog.confirm(message, {title: 'Rotate ' + label, okText: 'Rotate ' + label, danger: true})) return;
        var self = this;
        rotateFn(function(error, model) {
            if (error) {
                console.error('Error rotating ' + label + ':', error);
                dialog.alert('Error rotating ' + label + '. Please try again.');
            } else {
                console.log(label + ' rotated successfully');
                self.updateClipboardButtons();
            }
        });
    },

    rotateSecret: function() {
        this.confirmRotate(
            'Generate a new client secret? Your old secret will be invalidated and any existing integrations will need to be updated.',
            app.developer.rotateSecret.bind(app.developer), 'client secret'
        );
    },

    rotateApiKey: function() {
        this.confirmRotate(
            'Generate a new API key? Your old API key will be invalidated and any existing integrations will need to be updated.',
            app.developer.rotateApiKey.bind(app.developer), 'API key'
        );
    },

    rotateWebhooksSecret: function() {
        this.confirmRotate(
            'Generate a new webhooks secret? You will need to update the secret in all of your webhook receivers.',
            app.developer.rotateWebhooksSecret.bind(app.developer), 'webhooks secret'
        );
    },

    updateWebhookDisabledLabels: function() {
        if (!this.model || !this.model.webhooks) return;
        for (var i = 0; i < 3; i++) {
            var param = this.webhooksSettings.get('webhook_url_' + (i + 1));
            if (!param) continue;
            var disabled = this.model.webhooks[i] && this.model.webhooks[i].failures >= 100;
            param.set('label', 'URL ' + (i + 1) + (disabled ? ' (DISABLED)' : ''));
            param.set('rightColContent', disabled ? webhookReenableButton() : '');
        }
    },

    reEnableWebhook: function() {
        app.developer.reEnableWebhook(null, function(error) {
            if (error) {
                dialog.alert('Error re-enabling webhooks. Please try again.');
            } else {
                console.log('Webhooks re-enabled');
            }
        });
    },

    testAuthorization: function() {
        const redirectUri = this.model.redirectUris()[0];
        if (!this.model.oauth_client_id || !redirectUri) {
            dialog.alert('Please configure your Service Name and Redirect URI first.');
            return;
        }

        // Generate a random state for testing
        const testState = 'test_' + Math.random().toString(36).substring(2, 15);
        
        const currentHost = window.location.hostname;
        const authUrl = `https://${currentHost}?client_id=${this.model.oauth_client_id}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&state=${testState}`;
        const popup = window.open(
            authUrl,
            'oauth_test',
            'width=600,height=700,scrollbars=yes,resizable=yes,status=yes,location=yes,toolbar=no,menubar=no'
        );
        
        if (popup) {
            popup.focus();
            console.log('Authorization test opened with state:', testState);
        } else {
            dialog.alert('Popup blocked. Please allow popups for this site and try again.');
        }
    },

    testTokenRequest: function() {
        if (!this.model.oauth_client_id || !this.model.oauth_client_secret) {
            dialog.alert('Please ensure you have a Client ID and Client Secret configured first.');
            return;
        }

        const button = this.setButtonState('.test-token-button', true, 'Testing...');

        let serviceAuthDomain = app.config.firebase.serviceAuthDomain;
        if (app.config.env === "development") {
            serviceAuthDomain = "dev." + serviceAuthDomain;
        }

        const tokenUrl = `https://${serviceAuthDomain}/service/token`;
        const personKey = app.auth.personKey;

        const formData = new URLSearchParams();
        formData.append('grant_type', 'authorization_code');
        formData.append('code', personKey);
        formData.append('client_id', this.model.oauth_client_id);
        formData.append('client_secret', this.model.oauth_client_secret);

        fetch(tokenUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
            this.handleTokenResponse(data, button);
        })
        .catch(error => {
            this.handleTokenError(error, button);
        });
    },

    handleTokenResponse: function(data, button) {
        if (data.error || data.message) {
            const errorText = data.error || data.message || 'Unknown error';
            if (this.isAuthorizationError(errorText)) {
                dialog.alert('Token request failed. This may indicate that your authorization code is invalid or expired. Try running the Test Authorization first to get a fresh authorization code.');
                data.suggestion = 'Run Test Authorization first';
            }
            this.updateTokenResponseDisplay('Test Response (Error)', data, false);
            this.resetButton(button, 'Test Token Request');
            return;
        }
        
        if (data.access_token) {
            this.testAccessToken = data.access_token;
        }
        this.updateTokenResponseDisplay('Test Response', data, true);
        this.resetButton(button, 'Test Token Request');
    },

    handleTokenError: function(error, button) {
        console.error('Token request failed:', error);
        
        const errorMessage = error.message || 'Request failed';
        let displayError = { error: errorMessage };
        
        if (this.isAuthorizationError(errorMessage)) {
            dialog.alert('Token request failed. This may indicate that your authorization code is invalid or expired. Try running the Test Authorization first to get a fresh authorization code.');
            displayError.suggestion = 'Run Test Authorization first';
        }
        
        this.updateTokenResponseDisplay('Test Response (Error)', displayError, false);
        this.resetButton(button, 'Test Token Request');
    },

    isAuthorizationError: function(errorText) {
        const authErrorKeywords = ['invalid', 'expired', 'unauthorized', 'forbidden', 'code'];
        return authErrorKeywords.some(keyword => 
            errorText.toLowerCase().includes(keyword)
        );
    },

    resetButton: function(button, text) {
        button.disabled = false;
        button.textContent = text;
    },

    updateTokenResponseDisplay: function(title, responseData, isSuccess) {
        const headerElement = document.getElementById('token-response-header');
        if (headerElement) {
            const colorClass = isSuccess ? 'text-success' : 'text-danger';
            headerElement.innerHTML = `<span class="${colorClass}">${title}:</span>`;
        }

        const responseElement = document.getElementById('token-response-example');
        if (responseElement) {
            let content = '';
            
            if (typeof responseData === 'object' && responseData !== null) {
                const entries = Object.entries(responseData);
                content = entries.map(([key, value]) => {
                    let formattedValue;
                    if (typeof value === 'string') {
                        if (key === 'access_token' && value.length > 20) {
                            formattedValue = `"${value.substring(0, 20)}..."`;
                        } else {
                            formattedValue = `"${value}"`;
                        }
                    } else if (typeof value === 'object' && value !== null) {
                        if (Array.isArray(value)) {
                            formattedValue = `[${value.map(v => typeof v === 'string' ? `"${v}"` : JSON.stringify(v)).join(', ')}]`;
                        } else {
                            formattedValue = JSON.stringify(value);
                        }
                    } else {
                        formattedValue = value;
                    }
                    return `&nbsp;&nbsp;"${key}": ${formattedValue}`;
                }).join(',<br/>');
            } else {
                content = `&nbsp;&nbsp;${responseData}`;
            }
            
            responseElement.innerHTML = `
                {<br/>
                ${content}<br/>
                }
            `;
        }
    },

    testVerifyAuthorization: function() {
        if (!this.testAccessToken) {
            dialog.alert('Please run the Test Token Request first to get an access token.');
            return;
        }

        const button = this.query('.test-verify-button');
        button.disabled = true;
        button.textContent = 'Testing...';

        const currentDomain = app.config.baseApiUrl;
        const verifyUrl = `${currentDomain}/service/test`;

        fetch(verifyUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.testAccessToken}`
            }
        })
        .then(response => response.json())
        .then(data => {
            this.updateResponseDisplay('verify-response-header', 'verify-response-example', 'Test Response', data, true);
            this.setButtonState('.test-verify-button', false, 'Test Authorization Verification');
        })
        .catch(error => {
            console.error('Authorization verification failed:', error);
            this.updateResponseDisplay('verify-response-header', 'verify-response-example', 'Test Response (Error)', { error: error.message || 'Request failed' }, false);
            this.setButtonState('.test-verify-button', false, 'Test Authorization Verification');
        });
    },

    testVybitList: function() {
        if (!this.testAccessToken) {
            dialog.alert('Please run the Test Token Request first to get an access token.');
            return;
        }

        const button = this.query('.test-vybit-list-button');
        button.disabled = true;
        button.textContent = 'Testing...';

        const currentDomain = app.config.baseApiUrl;
        const vybitListUrl = `${currentDomain}/v1/vybits`;

        fetch(vybitListUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.testAccessToken}`
            }
        })
        .then(response => response.json())
        .then(data => {
            const vybitsArray = Array.isArray(data) ? data : Object.values(data);
            this.testVybits = vybitsArray;

            this.populateVybitDropdown(vybitsArray);
            
            this.updateResponseDisplay('vybit-list-response-header', 'vybit-list-response-example', 'Test Response', data, true);
            this.setButtonState('.test-vybit-list-button', false, 'Test Vybit List Request');
        })
        .catch(error => {
            console.error('Vybit list request failed:', error);
            this.updateResponseDisplay('vybit-list-response-header', 'vybit-list-response-example', 'Test Response (Error)', { error: error.message || 'Request failed' }, false);
            this.setButtonState('.test-vybit-list-button', false, 'Test Vybit List Request');
        });
    },

    testTriggerVybit: function() {
        if (!this.testAccessToken) {
            dialog.alert('Please run the Test Token Request first to get an access token.');
            return;
        }

        if (!this.testVybits || !Array.isArray(this.testVybits) || this.testVybits.length === 0) {
            dialog.alert('Please run the Test Vybit List Request first to get vybits to trigger.');
            return;
        }

        const dropdown = document.getElementById('vybit-select');
        const selectedTriggerKey = dropdown ? dropdown.value : null;

        if (!selectedTriggerKey) {
            dialog.alert('Please select a vybit from the dropdown first.');
            return;
        }

        if (!this.validateTriggerParameters()) {
            return;
        }

        const button = this.query('.test-trigger-button');
        button.disabled = true;
        button.textContent = 'Testing...';

        const vybKey = selectedTriggerKey;

        const currentDomain = app.config.baseApiUrl;
        const triggerUrl = `${currentDomain}/v1/vybit/${vybKey}/trigger`;
        
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.testAccessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.buildTriggerPayload())
        };

        fetch(triggerUrl, requestOptions)
        .then(response => response.json())
        .then(data => {
            this.updateResponseDisplay('trigger-response-header', 'trigger-response-example', 'Test Response', data, true);
            this.setButtonState('.test-trigger-button', false, 'Test Vybit Trigger');
        })
        .catch(error => {
            console.error('Vybit trigger failed:', error);
            this.updateResponseDisplay('trigger-response-header', 'trigger-response-example', 'Test Response (Error)', { error: error.message || 'Request failed' }, false);
            this.setButtonState('.test-trigger-button', false, 'Test Vybit Trigger');
        });
    },

    updateResponseDisplay: function(headerElementId, responseElementId, title, responseData, isSuccess) {
        const headerElement = document.getElementById(headerElementId);
        if (headerElement) {
            const colorClass = isSuccess ? 'text-success' : 'text-danger';
            headerElement.innerHTML = `<span class="${colorClass}">${title}:</span>`;
        }

        const responseElement = document.getElementById(responseElementId);
        if (responseElement) {
            let content = '';
            
            if (typeof responseData === 'object' && responseData !== null) {
                if (this.isVybitListResponse(responseData)) {
                    content = this.formatAsVybitArray(responseData);
                } else {
                    const entries = Object.entries(responseData);
                    content = entries.map(([key, value]) => {
                        let formattedValue;
                        if (typeof value === 'string') {
                            formattedValue = `"${value}"`;
                        } else if (typeof value === 'object' && value !== null) {
                            if (Array.isArray(value)) {
                                if (value.length > 3) {
                                    const preview = value.slice(0, 2);
                                    formattedValue = `[${preview.map(v => this.formatVybitObject(v)).join(', ')}, ... (${value.length} total)]`;
                                } else {
                                    formattedValue = `[${value.map(v => this.formatVybitObject(v)).join(', ')}]`;
                                }
                            } else {
                                formattedValue = JSON.stringify(value);
                            }
                        } else {
                            formattedValue = value;
                        }
                        return `&nbsp;&nbsp;"${key}": ${formattedValue}`;
                    }).join(',<br/>');
                }
            } else {
                content = `&nbsp;&nbsp;${responseData}`;
            }
            
            responseElement.innerHTML = `
                {<br/>
                ${content}<br/>
                }
            `;
        }
    },

    isVybitListResponse: function(responseData) {
        const keys = Object.keys(responseData);
        return keys.length > 0 && keys.every(key => {
            const isNumeric = /^\d+$/.test(key);
            const hasVybitProps = responseData[key] && 
                                 typeof responseData[key] === 'object' && 
                                 (responseData[key].triggerKey || responseData[key].trigger_key || responseData[key].name);
            return isNumeric && hasVybitProps;
        });
    },

    formatAsVybitArray: function(responseData) {
        const vybitEntries = Object.values(responseData);
        const formattedVybits = vybitEntries.map(vybit => {
            return `&nbsp;&nbsp;&nbsp;&nbsp;${this.formatVybitObjectDetailed(vybit)}`;
        });
        
        let arrayContent = `&nbsp;&nbsp;[<br/>${formattedVybits.join(',<br/>')}<br/>&nbsp;&nbsp;]`;
        
        return arrayContent;
    },

    formatVybitObjectDetailed: function(vybitObj) {
        if (typeof vybitObj === 'object' && vybitObj !== null) {
            const preferredOrder = ['name', 'triggerKey', 'trigger_key', 'id', 'sound', 'description'];
            const orderedEntries = [];
            const remainingEntries = [];
            
            preferredOrder.forEach(prop => {
                if (vybitObj.hasOwnProperty(prop)) {
                    orderedEntries.push([prop, vybitObj[prop]]);
                }
            });
            
            Object.entries(vybitObj).forEach(([key, value]) => {
                if (!preferredOrder.includes(key)) {
                    remainingEntries.push([key, value]);
                }
            });
            
            const allEntries = [...orderedEntries, ...remainingEntries];
            const formattedProps = allEntries.map(([key, value]) => {
                const formattedValue = typeof value === 'string' ? `"${value}"` : value;
                return `"${key}": ${formattedValue}`;
            }).join(', ');
            
            return `{${formattedProps}}`;
        }
        return typeof vybitObj === 'string' ? `"${vybitObj}"` : vybitObj;
    },

    formatVybitObject: function(vybitObj) {
        if (typeof vybitObj === 'object' && vybitObj !== null) {
            const preferredOrder = ['id', 'name', 'triggerKey', 'trigger_key', 'sound', 'description'];
            const orderedEntries = [];
            const remainingEntries = [];
            
            preferredOrder.forEach(prop => {
                if (vybitObj.hasOwnProperty(prop)) {
                    orderedEntries.push([prop, vybitObj[prop]]);
                }
            });
            
            Object.entries(vybitObj).forEach(([key, value]) => {
                if (!preferredOrder.includes(key)) {
                    remainingEntries.push([key, value]);
                }
            });
            
            const allEntries = [...orderedEntries, ...remainingEntries];
            const formattedProps = allEntries.map(([key, value]) => {
                const formattedValue = typeof value === 'string' ? `"${value}"` : value;
                return `"${key}": ${formattedValue}`;
            }).join(', ');
            
            return `{${formattedProps}}`;
        }
        return typeof vybitObj === 'string' ? `"${vybitObj}"` : vybitObj;
    },

    onVybitSelectionChange: function(e) {
        const selectedTriggerKey = e.target.value;
        this.updateTriggerUrl(selectedTriggerKey);
    },

    updateTriggerUrl: function(triggerKey) {
        const urlDisplay = document.getElementById('trigger-url-display');
        if (!urlDisplay) return;

        const currentDomain = app.config.baseApiUrl;
        const displayKey = triggerKey || '{key}';

        const payload = this.buildTriggerPayload();
        const escapedPayload = this.escapeHtmlInPayload(payload);

        urlDisplay.innerHTML = `
            POST ${currentDomain}/v1/vybit/${displayKey}/trigger<br/>
            Authorization: Bearer ACCESS_TOKEN<br/>
            Content-Type: application/json<br/><br/>
            Body:<br/>
            <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; font-size: 12px;">${JSON.stringify(escapedPayload, null, 2)}</pre>
        `;
    },

    populateVybitDropdown: function(vybits) {
        const dropdown = document.getElementById('vybit-select');
        if (!dropdown || !Array.isArray(vybits)) return;

        dropdown.innerHTML = '';
        
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = 'Select a vybit to trigger...';
        dropdown.appendChild(defaultOption);

        vybits.forEach(vybit => {
            const option = document.createElement('option');
            const vybKey = vybit.key;
            const name = vybit.name || 'Unnamed Vybit';

            if (vybKey) {
                option.value = vybKey;
                option.textContent = name;
                dropdown.appendChild(option);
            }
        });

        dropdown.disabled = false;
    },

    onTriggerParameterChange: function() {
        const dropdown = document.getElementById('vybit-select');
        const selectedTriggerKey = dropdown ? dropdown.value : null;
        this.updateTriggerUrl(selectedTriggerKey);
    },

    getTriggerParameterElements: function() {
        return {
            message: document.getElementById('trigger-message'),
            image: document.getElementById('trigger-image'),
            link: document.getElementById('trigger-link'),
            log: document.getElementById('trigger-log')
        };
    },

    hasOptionalParameters: function() {
        const elements = this.getTriggerParameterElements();
        return Object.values(elements).some(el => el && el.value.trim());
    },

    buildTriggerPayload: function() {
        const payload = {};
        const elements = this.getTriggerParameterElements();
        const fieldMapping = {
            message: 'message',
            image: 'imageUrl', 
            link: 'linkUrl',
            log: 'log'
        };

        Object.entries(elements).forEach(([key, element]) => {
            if (element && element.value.trim()) {
                payload[fieldMapping[key]] = element.value.trim();
            }
        });
        
        return payload;
    },

    validateTriggerParameters: function() {
        const elements = this.getTriggerParameterElements();
        const urlFields = [
            { element: elements.image, name: 'Image URL' },
            { element: elements.link, name: 'Link URL' }
        ];

        for (const field of urlFields) {
            const value = field.element?.value?.trim();
            if (value && !app.utils.isValidURL(value)) {
                //focus the field once the message is dismissed, or the dialog hands focus back to the button
                dialog.alert(`Invalid ${field.name}`).then(() => field.element.focus());
                return false;
            }
        }
        
        return true;
    },

    escapeHtmlInPayload: function(payload) {
        const escapedPayload = {...payload};
        if (escapedPayload.log) {
            escapedPayload.log = escapedPayload.log
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
        return escapedPayload;
    }

});

module.exports = DeveloperFullView;